interface ILeapHomeContainerProps {
  content: JSX.Element;
}

const AbstractionHomeContainer = ({ content }: ILeapHomeContainerProps) => (
  <div>{content}</div>
);

export default AbstractionHomeContainer;
